<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="levels"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalLevels"
                  :loading="levelsLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-format-list-numbered
          </v-icon>
          Virtual Learning Environment CMS: Levels
        </v-card-title>

        <v-card-title class="mb-10">

          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add a Level
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Levels"
              filled
              rounded
              single-line
              hide-details
              placeholder="Search levels"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.tags="{ item }">
        <TagsDisplay :items="item.tags"/>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="deleteItem(item)"
        >
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>

    <LevelAdd/>
    <LevelEdit/>
    <LevelDelete/>

  </v-card>
</template>

<script>

import { mapActions, mapGetters, mapState } from "vuex";
import LevelAdd from "@/components/Levels/LevelAdd";
import LevelEdit from "@/components/Levels/LevelEdit";
import LevelDelete from "@/components/Levels/LevelDelete";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";
import TagsDisplay from "@/components/common/TagsDisplay";

export default {
  name: "Levels",
  components: {TagsDisplay, RefreshTableHeader, RefreshTableFooter, LevelAdd, LevelEdit, LevelDelete},
  computed: {
    ...mapState([
      'levelsLoading', 'totalLevels',
    ]),
    ...mapGetters([
        'levels', 'levelsLoading', 'totalLevels', 'currentLevelItem', 'dataTableFooterProps',
    ]),
  },
  methods: {
    ...mapActions([
      'getLevels',
      'getLevel',
      'clearLevelApiError',
      'setOpenDialog',
      'setLevelPaginationOptions',
      'setLevelsSearch',
    ]),
    addItem() {
      this.clearLevelApiError();
      this.setOpenDialog('levelAdd');
    },
    async editItem(item) {
      this.clearLevelApiError();
      this.setOpenDialog('levelEdit');
      await this.getLevel(item);
      if (!this.currentLevelItem) {
        this.getLevels();
      }
    },
    async deleteItem(item) {
      this.clearLevelApiError();
      this.setOpenDialog('levelDelete');
      await this.getLevel(item);
      if (!this.currentLevelItem) {
        this.getLevels();
      }
    },
    refresh() {
      this.getLevels();
    },
    clear() {
      this.setLevelsSearch('');
    },
  },
  mounted() {
    this.setLevelsSearch('');
    this.getLevels();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'Certification Level Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Sites',
          align: 'start',
          value: 'tags',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setLevelPaginationOptions(this.options);
        this.getLevels();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setLevelsSearch(this.search ?? '');
        this.getLevels();
      },
    },
  },
};
</script>